export const ru = {
    'actions-title': 'Действия',
    'add-banner': 'Добавить баннер',
    'add-group': 'Добавить группу',
    aim: 'Нацелиться на объявление',
    bannerAimingDisabledMessage: 'Нацеливание работает для запущенных кампаний и баннеров, прошедших модерацию',
    copy: 'Копировать',
    delete: 'Удалить',
    edit: 'Редактировать',
    'go-to-report-master': 'Перейти в Мастер отчетов',
    'internal-tool-title': 'Внутренние инструменты',
    moderate: 'Отправить на модерацию',
    moderateAccept: 'Подтвердить модерацию',
    moderateAcceptBannersAdditions: 'Модерация: принять уточнения',
    moderateByClient: 'Отправить на модерацию',
    notEditable: 'Редактирование недоступно',
    'regions-transform': 'Настроить регионы показа',
    remoderate: 'Перемодерировать',
    remoderateBannersAdditions: 'Перемодерация уточнений',
    resume: 'Активировать',
    sendBK: 'Отправить в БК',
    'show-params': 'Посмотреть параметры',
    suspend: 'Остановить'
};
